import cn from 'classnames';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from 'react-icons/md';

import { CATEGORIES } from '../../constants/routes';
import { RenderedProducts } from '../../store/products';
import { isProductDetailsPage } from '../../utils/products';

import styles from './CategoriesAccordion.module.scss';

export default function CategoriesAccordion({ categoryName, categorySlug, subCategories, active, slug }) {
  const [isProductDetails, setIsProductDetails] = useState(false);

  function onClickLink() {
    RenderedProducts.update({});
  }

  useEffect(() => {
    const _isProductDetailsPage = isProductDetailsPage(slug);
    setIsProductDetails(_isProductDetailsPage);
  }, [slug]);

  return (
    <>
      <div
        className={cn({
          [styles.containerSelected]: active,
          [styles.container]: !active,
        })}
      >
        <Link href={`${CATEGORIES}/${categorySlug}`}>
          <a
            className={cn({
              [styles.categoriesSelected]: active,
              [styles.categories]: !active,
              [styles.disableEvents]: active && !isProductDetails,
            })}
            onClick={onClickLink}
          >
            <div className={cn(styles[categorySlug], { [styles.isActiveCategory]: active })} />

            <div className={styles.innerContent}>
              <span>{categoryName}</span>
              {!active ? (
                <MdKeyboardArrowRight className={styles.arrow} />
              ) : (
                <MdKeyboardArrowDown className={styles.arrowActive} />
              )}
            </div>
          </a>
        </Link>
      </div>

      {active && (
        <div className={styles.subCategoriesContainer}>
          <Link href={`${CATEGORIES}/${categorySlug}`}>
            <a className={styles.subCategories} onClick={onClickLink}>
              Όλα
            </a>
          </Link>
        </div>
      )}
      {subCategories && active && (
        <div>
          {subCategories.map(subC => {
            const selected = slug[1] && slug[1] === subC.slugAscii;
            return (
              <div
                className={cn({
                  [styles.subCategoriesContainerSelected]: selected,
                  [styles.subCategoriesContainer]: !selected,
                })}
                key={subC._id}
              >
                <Link href={`${CATEGORIES}/${categorySlug}/${subC.slugAscii}`}>
                  <a
                    className={cn({
                      [styles.subCategoriesSelected]: selected,
                      [styles.subCategories]: !selected,
                      [styles.disableEvents]: selected && !isProductDetails,
                    })}
                  >
                    {subC.name}
                  </a>
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
